const { userApi } = require('./API');

class UserService {
  // Get User
  static async getUser(id, token) {
    userApi.defaults.headers.common.Authorization = `Bearer ${token}`;
    const res = await userApi.get(`${id}`);
    const { data } = res;
    return data;
  }
}

export default UserService;
